import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Chip, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faListAlt, faPlay, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteDialog from '../../../../../components/DeleteDialog';


//export default class TablaProductos extends Component
export default function ModifierGroupOptionsDataTable({modifiers, modifierGroup, onDelete, isLoading})
{
    const [modifierToRemove,setModifierToRemove] = useState(null);
    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    const handleOpenDialog = (modifier) => {
        setModifierToRemove(modifier);
        setOpenDeleteDialog(true);
    }

    const columns = [
        {
            name : 'id',
            label : 'ID',
        },
        {
            name : 'name',
            label : 'Nombre',
        },
        {
            name : 'price',
            label : 'Precio',
        },
        {
            name : 'quantity',
            label : 'Cantidad',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    if(modifiers[dataIndex].quantity !== null)
                    {
                        return <Typography>${modifiers[dataIndex].quantity}</Typography>
                    }
                    else
                    {
                        return <Typography>N/A</Typography>
                    }
                        
                },
                    //let id = subCategorias[dataIndex].idSubCategoria;
                filter:false
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = modifiers[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                to={'/products/modifiers/update/'+modifiers[dataIndex].id} 
                                replace
                            >
                                <IconButton>
                                    <FontAwesomeIcon icon={faEdit}/>
                                </IconButton>
                            </Link>
                             <IconButton color='error' onClick={()=>handleOpenDialog(modifiers[dataIndex])}>
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </IconButton>
                        </div>
                    );
                },

                print : false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
                title={`Opciones del Grupo: ${modifierGroup}`}
                data={modifiers}
                columns={columns}
                options={options}
            />
            <DeleteDialog
                open={openDeleteDialog}
                title={'Eliminar Opción de Grupo'}
                message={'¿Está seguro que desea eliminar la opción "'+ (modifierToRemove ? modifierToRemove.name : '') +'"? Esta acción no se puede deshacer.'}
                isLoading={isLoading}
                onClose={ ()=> setOpenDeleteDialog(false) }
                onConfirm={ async () => {
                    await onDelete(modifierToRemove.id);
                    setOpenDeleteDialog(false);
                } }
            />
        </>
    )
}